import { useTranslation } from "react-i18next";
import { ChatContact } from "../../api/models/ConversationModel";
import { SearchIcon } from "@heroicons/react/outline";
import ChatContactsList from "./ChatContactsList";
import { useCurrentUser } from "../../context/AuthContext";
import { Conversation } from "@twilio/conversations";

type ChatNavigationProps = {
  conversationsList: ChatContact[];
  contactsList: ChatContact[];
  onSearch: (query: string) => void;
  onSelectConversation: (conversationId: string) => void;
  onSelectContact: (contact: ChatContact) => void;
  selectedConversation: Conversation | undefined;
  isLoadingContacts: boolean;
};

export default function ChatNavigation(props: ChatNavigationProps) {
  const currentUser = useCurrentUser();
  const {
    conversationsList,
    onSearch,
    contactsList,
    onSelectConversation,
    onSelectContact,
    selectedConversation,
    isLoadingContacts,
  } = props;
  const LocalBasePath = "page.chat";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });

  const onChangeSearchQuery: React.ChangeEventHandler<HTMLInputElement> = (
    e
  ) => {
    onSearch(e.target.value);
  };

  const onSelectChatContact = (contact: ChatContact) => {
    if (contact.conversationTwillioId) {
      onSelectConversation(contact.conversationTwillioId);
    } else {
      onSelectContact(contact);
    }
  };

  return (
    <nav className="bg-white" aria-label="Directory">
      <div className="sticky top-0 z-20 bg-white flex flex-col gap-[18px] px-[21px] py-7  ">
        <h2 className="text-lg leading-6 font-medium text-gray-900">
          {t("messages")}
        </h2>
        <div className="relative rounded-md shadow-sm">
          <div className="absolute inset-y-0 start-0 ps-3  flex items-center pointer-events-none">
            <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </div>
          <input
            type="text"
            name="search"
            id="search"
            className="block w-full ps-10 border border-gray-300 focus:ring-brandblue-500 focus:border-brandblue-500 text-sm rounded-md"
            placeholder={t("searchByName")}
            onChange={onChangeSearchQuery}
          />
        </div>
      </div>
      <div className="w-full flex flex-col">
        <h3 className="z-10   border-t border-b border-gray-300 bg-gray-100 px-6 py-2 flex justify-between	 text-xs  text-gray-900">
          <span>{t("conversations")}</span>
          <span>{conversationsList.length}</span>
        </h3>
        <div className="w-full">
          <ChatContactsList
            contacts={conversationsList}
            onSelectConversation={onSelectChatContact}
            selectedConversation={selectedConversation}
            isLoading={false}
          />
        </div>
      </div>
      <div className="w-full flex flex-col ">
        <div className="z-10 sticky  border-t border-b border-gray-300 bg-gray-100 px-6 py-2 flex justify-between	 text-xs  text-gray-900">
          <h3>{t("contacts")}</h3>
          <h3>{contactsList.length}</h3>
        </div>
        <div className="w-full">
          <ChatContactsList
            contacts={contactsList}
            onSelectConversation={onSelectChatContact}
            isLoading={isLoadingContacts}
          />
        </div>
      </div>
    </nav>
  );
}
